import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy, OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent implements OnInit, OnDestroy, OnChanges {
  @Input() value: string;
  @Input() resetValue = false;
  // tslint:disable-next-line:no-output-rename
  @Output('searchTriggered') searchBoxTriggeredEmitter: EventEmitter<string> =
    new EventEmitter<string>();
  @Output('searchBoxCleared') searchBoxClearedEmitter: EventEmitter<void> =
    new EventEmitter<void>();
  @Output('searchBoxResetValue')
  searchBoxResetValueEmitter: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup;
  subSink: SubSink;

  constructor(private readonly formBuilder: FormBuilder) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    this.initForm();
  }

  get search(): AbstractControl {
    return this.form.get('search');
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resetValue) {
      if (changes.resetValue.currentValue) {
        this.initForm();
      }
      this.searchBoxResetValueEmitter.emit();
    }
  }

  clearSearchBox(): void {
    this.value = '';
    this.initForm();
    this.searchBoxClearedEmitter.emit();
  }

  initForm() {
    this.form = this.formBuilder.group({
      search: new FormControl(this.value ? this.value : '', [
        Validators.required,
        Validators.min(1),
      ]),
    });
    this.subSink.sink = this.search.valueChanges
      .pipe(debounce(() => interval(500)))
      .subscribe((value: string) => {
        if (value !== this.value) {
          this.searchBoxTriggeredEmitter.emit(value);
        }
      });
  }
}
